const getters = {
  agents: (state) => state.agents,
  agentsUnasigned: (state) =>
    state.agents.filter((agent) => agent.company.linesId === 0),
  simpleAgents: (state) => state.simpleAgents,
}

export default getters
